import { __cBotService } from '@/services/client/__c.bot.service'
import { useMutation } from '@tanstack/react-query'

export const useBotNoticeErrorMutation = () => {
  return useMutation({
    mutationFn: async (message: string) => {
      try {
        const response = await __cBotService.sendErrorNotice(message)
        return response
      } catch (error) {
        console.error('🧙 ~ error:', error)
        return null
      }
    },
  })
}
